import request from '@utils/request';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { SpaPackageListingType } from 'shared-types/SpaPackage';
import { SPA_AVAILABILITY_TIMEOUT } from './consts';
import { Routes } from '@common/constants';

export function useGetAllSpaPackages(propertyId: number, language: string, perPage = 0) {
  const { data, isFetching } = useQuery({
    queryKey: getAllSpaPackagesKey(propertyId, language, perPage),
    queryFn: () => getAllSpaPackages(propertyId, language, perPage),
  });
  if (!data?.data) {
    return { isFetching, spaTreatments: [], total: 0 };
  }
  const spaDays = data.data.map((spaDay) => ({
    ...spaDay,
    linkRoute: Routes.SPA_DAY_DETAIL,
    linkParams: { id: spaDay.id },
  }));
  return { isFetching, data: spaDays as SpaPackageListingType[], total: data.total };
}

export async function getAllSpaPackages(propertyId: number, language: string, perPage: number) {
  const { data } = await request.get(`${propertyId}/spa-packages/${language}`, {
    params: { perPage },
    isPayloadCaseConverterDisabled: true,
    timeout: SPA_AVAILABILITY_TIMEOUT,
  });
  return data;
}

export const getAllSpaPackagesKey = (propertyId: number, language: string, perPage: number) => [
  'spaPackages',
  'all',
  propertyId,
  language,
  perPage,
];

export const getAllSpaPackagesPrefetch = (
  queryClient: QueryClient,
  propertyId: number,
  language: string,
  perPage = 0
) =>
  queryClient.prefetchQuery(getAllSpaPackagesKey(propertyId, language, perPage), () =>
    getAllSpaPackages(propertyId, language, perPage)
  );
